import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import { useDarkMode, useScrollToTop } from './hooks';

import { Blog, Home, Pricing, SignIn, SignUp } from './pages';
import { Layout } from './partials';

// Wrapper component to reset scrolling on route change.
function ScrollToTop({ children = null }) {
  useScrollToTop();
  return children;
}

// Wrapper component for shared Layout
function RouteWithLayout({ component: Component, children, ...rest }) {
  return (
    <Route {...rest}>
      <Layout>{Component ? <Component /> : children}</Layout>
    </Route>
  );
}

function App() {
  const setDarkMode = useDarkMode()[1];

  return (
    <Router>
      <ScrollToTop>
        <Switch>
          <RouteWithLayout exact path="/">
            <Home onClickDemo={() => setDarkMode(prev => !prev)} />
          </RouteWithLayout>
          <RouteWithLayout path="/blog" component={Blog} />
          <RouteWithLayout path="/pricing" component={Pricing} />
          <Route path="/sign-in" component={SignIn} />
          <Route path="/sign-up" component={SignUp} />
          <Route path="*">
            <Redirect to="/" />
          </Route>
        </Switch>
      </ScrollToTop>
    </Router>
  );
}

export default App;
